import store from '../store'
import Block from './Block'

export default class Form extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()

    setTimeout(() => {
      this.render()
      store.smoothScroll && store.smoothScroll.update()

    }, 500);
  }

  getElems() {
    super.getElems()
    this.$captcha = this.el.querySelector('.ginput_recaptcha')
  }

  events() {
    super.events()
  }

  render() {
    store.noFirstLoaded && this.$captcha && grecaptcha.render(this.$captcha)
  }
}
